var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { disgardOldValue, list, object, primitive, withDefault } from '../../../utils/serializr/serializr';
import { ChoiceOption } from '../ChoiceOption/ChoiceOption';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
class ChoiceStore {
    parent;
    allOptions;
    numberOfOptions = 3;
    numberOfTries;
    constructor({ parent }) {
        editObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get multiple() {
        return this.question.choiceInfo.hasMultipleCorrectOptions ? 1 : 0;
    }
    set multiple(v) { }
    static get serializeInfo() {
        return {
            props: {
                allOptions: withDefault(list(object(ChoiceOption, { parentDepth: 2 })), [{}, {}, {}, {}, {}, {}, {}, {}, {}]),
                multiple: disgardOldValue(primitive),
                numberOfOptions: true,
                numberOfTries: withDefault(primitive, 1),
            },
        };
    }
}
__decorate([
    editable('shallow')
], ChoiceStore.prototype, "allOptions", void 0);
__decorate([
    editable()
], ChoiceStore.prototype, "numberOfOptions", void 0);
__decorate([
    editable()
], ChoiceStore.prototype, "numberOfTries", void 0);
__decorate([
    memoize
], ChoiceStore, "serializeInfo", null);
export { ChoiceStore };
